import JobViewTabs from './Tabs';
import { useParams } from 'react-router';
import { Box, styled } from '@mui/material';
import { TabbedJobViewHeader } from './TabbedJobViewHeader/TabbedJobViewHeader';

const TabbedJobView: React.FC = () => {
  const { id, tab } = useParams<{ id: string; tab: string }>();
  const jobId = Number(id);

  return (
    <Exterior>
      <Container>
        <TabbedJobViewHeader jobId={jobId} />
        <JobViewTabs jobId={jobId} tab={tab} />
      </Container>
    </Exterior>
  );
};

export default TabbedJobView;

const Container = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.contrastText,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: theme.spacing(4),
  width: '100%',
  maxWidth: '1216px',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
    flexDirection: 'column',
    alignItems: 'end',
    height: '100%',
    width: '100%',
  },
}));

const Exterior = styled(Box)(({ theme }) => ({
  backgroundColor: `${theme.palette.primary.contrastText} !important`,
  display: 'flex',
  justifyContent: 'center',
}));
